<template>
    <div v-if="haveVideo">
        <div class="video-container w-full h-full w-100 h-100 cursor-pointer">
            <vue-plyr
                v-if="
                    videoPath.indexOf('MP4') > -1 ||
                    videoPath.indexOf('mp4') > -1 ||
                    videoPath.indexOf('MOV') > -1 ||
                    videoPath.indexOf('mov') > -1 ||
                    videoPath.indexOf('blob') > -1
                "
                ref="video"
                :options="options"
            >
                <video id="video-block" class="h-full m-auto h-100 w-100" playsinline allowautoplay>
                    <source :src="videoPath" type="video/mp4" />
                </video>
            </vue-plyr>
            <vue-plyr v-else ref="youtube" :options="options">
                <div class="plyr__video-embed">
                    <iframe
                        id="video-block"
                        :src="'https://www.youtube.com/embed/' + videoPath"
                        playsinline
                        allowautoplay
                    ></iframe>
                </div>
            </vue-plyr>
        </div>
    </div>
</template>

<script>
import VuePlyr from 'vue-plyr'
export default {
    components: {
        VuePlyr
    },
    props: {
        videoMeta: {
            type: Object
        },

        timeDuration: {
            type: Array
        },

        addVideo: {
            type: Boolean
        },

        fullscreen: {
            type: Boolean,
            default: false
        },

        sponsor: {
            type: Boolean,
            default: false
        },

        userQuestionMusic: {
            type: Boolean,
            default: true
        },

        isEmbed: {
            type: Boolean,
            default: false
        },

        videoPath: {
            type: String,
            default: null
        }
    },

    mounted() {
        if (window.matchMedia('(max-width: 500px)').matches) {
            this.options = {
                ...this.options,
                fullscreen: {
                    enabled: this.fullscreen,
                    iosNative: this.fullscreen
                }
            }
        }

        this.setPlayer()
        this.addVideo ? (this.isAddVideo = true) : (this.isAddVideo = false)
    },

    watch: {
        videoPath: {
            handler() {
                this.$nextTick(() => {
                    this.haveVideo = false

                    let timer = null
                    setTimeout(() => {
                        this.haveVideo = true
                        clearTimeout(timer)
                    }, 500)
                })

                this.fetchVideo(this.videoMeta)
            },
            deep: true
        },

        timeDuration() {
            this.$nextTick(() => {
                this.setTimePlayer()
            })
        }
    },

    data() {
        return {
            player: null,
            stopTime: 0,
            firstSetTime: false,
            firstPlay: true,
            isAddVideo: false,
            options: {
                fullscreen: {
                    enabled: this.fullscreen,
                    iosNative: this.fullscreen
                },
                playsinline: true,
                muted: true,
                controls: ['play-large', 'play', 'mute', 'volume', 'fullscreen']
            },
            haveVideo: false,
            onPlay: false,
            clickVideo: 0,
            hidePlayer: false
        }
    },

    methods: {
        setPlayer() {
            if (this.videoMeta.video.length > 0) {
                this.haveVideo = true

                this.$nextTick(() => {
                    this.setPlayerSetting()
                })
            }
        },

        hideVolume(hide) {
            const volume = document.querySelector('.plyr__volume')

            if (hide) {
                if (volume) {
                    volume.style.display = 'none'
                }

                this.player.muted = true
            } else {
                if (volume) {
                    volume.style.display = 'flex'
                }

                this.player.muted = false
            }
        },

        hidePoster() {
            document.querySelector('.plyr__poster').style.display = 'none'
        },

        setPlayerSetting() {
            if (
                this.videoMeta.video.indexOf('MP4') > -1 ||
                this.videoMeta.video.indexOf('mp4') > -1 ||
                this.videoMeta.video.indexOf('MOV') > -1 ||
                this.videoMeta.video.indexOf('mov') > -1 ||
                this.videoMeta.video.indexOf('blob') > -1
            ) {
                this.player = this.$refs.video.player
            } else {
                this.player = this.$refs.youtube.player
            }

            // from device
            this.player.on('loadeddata', () => {
                this.playerConfig()

                this.$nextTick(() => {
                    this.$emit('handleOpenSetTime', this.videoMeta.flag)
                    if (this.onPlay == true && document.querySelector('#video-block')) {
                        document.querySelector('#video-block').autoplay = true

                        this.player.muted = false
                        if (this.videoMeta.video_mute || !this.userQuestionMusic) {
                            this.hideVolume(true)
                            this.player.muted = true
                        }
                    }

                    this.$emit('loaded')
                })
            })

            // from youtube
            this.player.on('ready', () => {
                if (this.player.provider === 'youtube') {
                    this.playerConfig()

                    this.$nextTick(() => {
                        this.$emit('handleOpenSetTime', this.videoMeta.flag)
                        if (this.onPlay == true) {
                            this.$nextTick(() => {
                                this.player.autoplay = true

                                this.player.muted = false
                                if (this.videoMeta.video_mute || !this.userQuestionMusic) {
                                    this.hideVolume(true)
                                    this.player.muted = true
                                }
                            })
                        }

                        this.$emit('loaded')
                    })
                }
            })

            this.player.on('timeupdate', () => {
                if (parseInt(this.player.currentTime) + 1.1 > this.stopTime) {
                    this.player.currentTime = this.timeDuration[0]
                    if (this.videoMeta.video_loop) {
                        this.player.play()
                        return
                    }
                    this.player.pause()
                }
            })

            this.player.on('play', () => {
                if (this.sponsor) {
                    this.onPlayVideo()
                }
            })
        },

        playerConfig() {
            this.$emit('maxValue', this.player.duration) //set max duration

            if (this.isEmbed) {
                this.hidePoster()
            }

            this.player.currentTime = this.timeDuration ? this.timeDuration[0] : 0

            this.stopTime = this.timeDuration ? this.timeDuration[1] : this.player.duration

            this.player.loop = this.videoMeta.video_loop
        },

        setTimePlayer() {
            this.player.currentTime = this.timeDuration[0]
            this.stopTime = this.timeDuration[1]
        },

        setPlay() {
            this.onPlay = true
        },

        setMuted(muted) {
            if (!this.videoMeta.video_mute) {
                if (!muted) {
                    this.hideVolume(false)
                } else {
                    this.hideVolume(true)
                }
            }
        },

        stopVideo() {
            if (this.player.playing) {
                this.player.pause()
                this.player.currentTime = this.timeDuration[0]
            }
        },

        endVideo() {
            this.player.stop()
        },

        fetchVideo(video) {
            const newSource = {
                type: 'video',
                sources: [
                    {
                        src: video.video,
                        type: video.type
                    }
                ]
            }
            this.$nextTick(() => {
                this.player.source = newSource
            })
        },

        onPlayVideo() {
            if (this.clickVideo === 0) {
                this.$emit('clickVideo')
                this.clickVideo += 1
            }
        }
    }
}
</script>

<style>
.plyr__video-embed {
    width: 100%;
    height: 100%;
    padding: 0;
}

.plyr__video-embed iframe {
    width: 100%;
    height: 100%;
    object-fit: unset;
}

.plyr__control--overlaid {
    background-color: #22292f;
}

.plyr--video .plyr__control:hover {
    background-color: #1c2227;
}

.plyr--full-ui input[type='range'] {
    color: #22292f;
}

.ytp-chrome-top {
    display: none;
}

.w-sm-100 {
    height: 100%;
}
</style>
